import angular from 'angular';

export const scrollToTop = (topValue) =>
  angular
    .element('html,body,.html,.body')
    .animate({ scrollTop: topValue }, 1000);
